import { useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from '../step1/OnboardingSequence';
import InputBar from '../InputBar';
import BPInput from '../../BionicUI/input/BPInput';
// import { PostUserProfileRequest } from 'core/models/users/profile/post-user-profile.model';
// import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
// import { useAuth } from 'context/auth.context';
// import { usePrivy } from '@privy-io/react-auth';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
import { isValidUrl } from 'utils/validation';

const WebsiteAddress = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const { nextStep, setProgressStep, setProjectInfo, projectInfo } =
    useOnboardingProjectStore();

  async function handleSubmit(inputText: string | null | undefined) {
    if (!inputText) return;
    setProjectInfo('website', inputText);
    nextStep();
  }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Now enter the website address of your project.',
            sound: 'projectStep/now-enter-website-address.mp3',
          }}
          onAnimComplete={() => setShowInputBar(true)}
        />
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(0)}>
          <BPInput
            value={projectInfo?.website ? projectInfo.website : ''}
            state="default"
            type="text"
            placeholder="Enter project website address"
            button={{
              state: 'primary',
              onClick: (e, inputText) => handleSubmit(inputText),
              title: 'Submit',
            }}
            validate={(text) => {
              const passed = isValidUrl(text);
              return passed;
            }}
          />
          <BPLinkButton onClick={nextStep}>Skip</BPLinkButton>
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default WebsiteAddress;
